import React from 'react'

const Others = () => {
  return (
    <div className="skills-content">
        <h3 className="skills-title ">Others </h3>
        <div className="skills-box">
            <div className="skills-group">
                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Github</h3>
                    {/* <span className="skills-level">Advanced</span> */}
                </div>
                </div>
                

                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Figma</h3>
                    {/* <span className="skills-level">Intermediate</span> */}
                </div>
                </div>
               

            
               
            </div>

            <div className="skills-group">
                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Pgadmin4</h3>
                    {/* <span className="skills-level">Basic</span> */}
                </div>
                </div>
                

                <div className="skills-data">
                <i className="bx bx-badge-check"></i>
                <div >
                    <h3 className="skills-name">Postman</h3>
                    {/* <span className="skills-level">Basic</span> */}
                </div>

                </div>
                
               
                

                
            </div>
        </div>
    </div>
  )
}

export default Others
